import { MDXProvider } from '@mdx-js/react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import mapObjIndexed from 'ramda/es/mapObjIndexed';
import React, { FC } from 'react';

import { ComponentMap } from 'types/jsx';

import { HeadingStyles } from '../../decorators/anchor-heading/styles';
import { identity } from '../../utils';
import builtInComponents from '../index';

type PropTypes<T> = {
  markup: string;
  mdxProcessor?: (children: React.ReactNode) => T;
  components?: ComponentMap;
  children?: React.ComponentType<T>;
  decorateComponents?: {
    [componentName: string]: (component: React.ReactNode) => React.ReactNode;
  };
};

const defaultRenderer: FC = ({ children }) => <>{children}</>;

const MarkdownProcessor = <T extends {}>({
  markup,
  // @ts-ignore
  mdxProcessor = identity,
  components = {},
  children: Children = defaultRenderer,
  decorateComponents: decorateComponentsFn,
}: PropTypes<T>): JSX.Element => {
  // OPT:: if this render function become too expensive to
  // run every render we can lift it to a HOC

  const allComponents = {
    ...builtInComponents,
    ...components,
  } as ComponentMap;

  const componentShortCodes = decorateComponentsFn
    ? {
        ...allComponents,
        ...mapObjIndexed((value, key) => {
          const componentToDecorate = allComponents[key];
          return value(componentToDecorate);
        }, decorateComponentsFn),
      }
    : allComponents;

  const shortCodes = {
    ...componentShortCodes,
    wrapper: function Wrapper({ children }: { children: React.ReactNodeArray }): JSX.Element {
      return <Children {...mdxProcessor(children)} />;
    },
  };

  return (
    <>
      <HeadingStyles />
      <MDXProvider components={shortCodes}>{markup && <MDXRenderer>{markup}</MDXRenderer>}</MDXProvider>
    </>
  );
};

export default MarkdownProcessor;
